import debug from 'bows';
import mediaQueries from './_media-queries';

const log = debug('panels');
export default class {
	constructor( node, opts ) {
		this.opts = Object.assign({
			openClass: 'panels__panel--open',
			openingClass: 'panels__panel--opening',
			closingClass: 'panels__panel--closing',
			hoverDuration: 125
		}, opts);

		this.node = typeof node === 'string' ? document.querySelector(node) : node;
		this.panels = Array.from( this.node.querySelectorAll('.panels__panel') );
		this.timeout = null;
		this.opened = -1;
		this.closing = null;
		this.opening = null;

		for( let i=0; i < this.panels.length; i++ ) {
			if ( this.panels[i].classList.contains( this.opts.openClass ) ) {
				this.opened = i;
				break;
			}
		}

		if ( this.opened === -1 ) {
			this.open(0);
		}

		this.panels.forEach((panel, index) => {
			panel.addEventListener('mouseover', () => {
				if ( typeof window.matchMedia === 'function' && ! window.matchMedia(mediaQueries.large_up).matches ) {
					return;
				}

				if ( typeof this.timeout === 'number' ) {
					window.clearTimeout(this.timeout);
				}

				this.timeout = window.setTimeout(() => {
					this.open(index)
				}, this.opts.hoverDuration );
			} );

			panel.addEventListener('mouseout', () => {
				if ( typeof this.timeout === 'number' ) {
					window.clearTimeout(this.timeout);
				}
			});

			panel.addEventListener('click', (e) => {
				if ( window.matchMedia(mediaQueries.large_up).matches && ( index !== this.opened || panel.classList.contains( this.opts.openingClass ) ) ) {
					e.preventDefault();
					this.open(index);
				}
			});

			// for keyboard navigation
			panel.addEventListener('focusin', () => {
				this.open(index);
			});

			let toggler = panel.querySelector('.panels__toggler');
			if ( toggler ) {
				toggler.addEventListener('click', () => {
					if ( panel.classList.contains( 'panels__panel--toggled' ) ) {
						panel.classList.remove( 'panels__panel--toggled' );
						toggler.innerHTML = '+';
					} else {
						panel.classList.add( 'panels__panel--toggled' );
						toggler.innerHTML = '-';
					}
				});
			}
		} );

		this._onTransitionEnd = (e) => {
			e.target.classList.remove(this.opts.closingClass);
			e.target.classList.remove(this.opts.openingClass);
			e.target.removeEventListener('transitionend', this._onTransitionEnd);
			log('_onTransitionEnd', this);
		}

		log(this);
	}

	open( index ) {
		if ( this.opened > -1 && index !== this.opened ) {
			this.panels[this.opened].addEventListener('transitionend', this._onTransitionEnd );
			this.panels[this.opened].classList.remove(this.opts.openClass);
			this.panels[this.opened].classList.add(this.opts.closingClass);
		}

		this.opened = index;

		if ( ! this.panels[this.opened].classList.contains( this.opts.openClass ) ) {
			this.panels[this.opened].addEventListener('transitionend', this._onTransitionEnd );
			this.panels[this.opened].classList.add(this.opts.openingClass);
			this.panels[this.opened].classList.add(this.opts.openClass);
		}
	}
}
